module.exports = __webpack_public_path__ + "img/collect-icon-music-select.7c5d06fd.svg";